import React, { useState } from 'react';
import {
  Table, TableHead, TableRow, TableCell,
  TableBody, TableContainer, Paper, TextField,
  IconButton, TableSortLabel, TablePagination
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const PendingReviewTable = ({ data, userData, onDetailsClick }) => {
  const [search, setSearch] = useState('');
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('componentName');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const navigate = useNavigate()

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleNavigateToPackage = (item) => {
    navigate(`/package?componentName=${item?.componentName}&templateName=${item.templateName}`, {
      state: {
        hd_id: userData?.hd_id,
        publishDate: item?.publishDate,
        componentName: item?.componentName,
        templateName: item?.templateName,
        from: 'dashboard'
      }
    });
  };

  const headers = [
    { id: 'componentName', label: 'Component Name' },
    // { id: 'summary', label: 'Summary' },
    { id: 'component_version', label: 'Version' },
    { id: 'component_status', label: 'Status' },
    { id: 'action_date', label: 'Action Date' },
    { id: 'action', label: 'Action', sortable: false },
  ];

  const filteredData = data.filter((item) =>
    item.componentName?.toLowerCase().includes(search.toLowerCase())
  );

  const sortedData = filteredData.sort(getComparator(order, orderBy));
  const paginatedData = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <TextField
        label="Search by Component Name"
        variant="outlined"
        size="small"
        fullWidth
        sx={{
            mb: 2,
            '& .MuiInputBase-input': {
            fontSize: '12px', // for input text
            },
            '& .MuiInputLabel-root': {
            fontSize: '12px', // for label
            },
        }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map(({ id, label, sortable = true }) => (
                <TableCell key={id}>
                  {sortable ? (
                    <TableSortLabel
                      active={orderBy === id}
                      direction={orderBy === id ? order : 'asc'}
                      onClick={() => handleSort(id)}
                      color="primary"
                    >
                      <strong>{label}</strong>
                    </TableSortLabel>
                  ) : (
                    <strong>{label}</strong>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((item, index) => (
              <TableRow key={index}>
                <TableCell
                    sx={(theme) => ({
                        color: theme.palette.primary.main,    
                        padding: "5px 10px",
                        fontWeight: theme.typography.fontWeightBold,
                        width: '150px',
                        cursor:'pointer' 
                    })}
                    onClick={() => handleNavigateToPackage(item)}
                    >
                    {item.componentName}
                    </TableCell>

               {/* <TableCell>
                {item?.info?.summary
                    ? item.info.summary.length > 80
                    ? `${item.info.summary.slice(0, 80)}...`
                    : item.info.summary
                    : '-'}
                </TableCell> */}
                    <TableCell>
                {item?.info?.underReview
                    ? `v${item.info.underReview}`
                    : '-'}
                </TableCell>
                <TableCell  sx={(theme) => ({
                         color:
                            item.component_status === 'underReview'
                                ? theme.palette.info.main
                                : item.component_status === 'submitted'
                                ? theme.palette.warning.main
                                :  item.component_status === 'tested' 
                                ?  theme.palette.success.main
                                :  theme.palette.text.primary,
                        fontSize: theme.typography.subtitle2.fontSize,     
                        fontWeight: theme.typography.fontWeightBold 
                    })}>{ item.component_status === 'underReview' ? 'Under Review' :
                          item.component_status === 'submitted' ? 'Pending' :
                          item.component_status === 'tested' ? 'Tested':
                          '_'


                    }</TableCell>
                <TableCell>
                  {item.action_date
                    ? new Date(item.action_date).toLocaleString()
                    : '-'}
                </TableCell>
                <TableCell sx={{ display: 'flex' }}>
                  <IconButton
                    onClick={() => handleNavigateToPackage(item)}
                    color="primary"
                  >
                    <VisibilityIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => onDetailsClick(item)}
                    color="primary"
                  >
                    <ArrowForwardIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {paginatedData.length === 0 && (
              <TableRow>
                <TableCell colSpan={headers.length} align="center">
                  No matching templates found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
};

export default PendingReviewTable;
